/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': '動作',
  'ai-smart-button.ai-actions.give-feedback-action.title': '提供意見反應',
  'ai-smart-button.ai-actions.help.section.text': '說明',
  'ai-smart-button.ai-actions.input.link-picker-button-label': '連結',
  'ai-smart-button.ai-actions.input.mention-button-label': '提及',
  'ai-smart-button.ai-actions.input.send-button-label': '傳送',
  'ai-smart-button.ai-actions.item.betaLozenge': '測試版',
  'ai-smart-button.ai-actions.item.newLozenge': '新',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': '新增圖示',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': '自動化圖示',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': '自動化',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': '瀏覽客服人員',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': '建立自動化',
  'ai-smart-button.ai-actions.rovo-agents.section.text': '工作室',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': '{name}，您好：',
  'ai-smart-button.ai-proactive-nudge.dismiss': '關閉',
  'ai-smart-button.feedback-action.ask-question-option': '提出問題',
  'ai-smart-button.feedback-action.cancel-button-label': '取消',
  'ai-smart-button.feedback-action.choose-feedback-option': '選擇一個',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': '描述錯誤或問題',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': '讓我們知道您的想法',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': '您想要知道什麼？',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': '讓我們知道您希望改善的項目',
  'ai-smart-button.feedback-action.feedback-modal-heading': '分享您的想法',
  'ai-smart-button.feedback-action.leave-comment-option': '留下留言',
  'ai-smart-button.feedback-action.report-bug-option': '回報錯誤',
  'ai-smart-button.feedback-action.research-participation-message': '我想要參與產品研究',
  'ai-smart-button.feedback-action.select-feedback-heading': '選取意見反應',
  'ai-smart-button.feedback-action.submit-button-label': '傳送意見反應',
  'ai-smart-button.feedback-action.suggest-improvement-option': '建議改進',
  'ai-smart-button.feedback-action.title': '提供意見反應',
  'ai-smart-button.feedback-item.icon-label': '意見反應圖示',
  'ai-smart-button.reference.close-button-label': '關閉',
};
